import React from "react";

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className="bg-red-50 text-red-500 p-3 rounded-md text-sm text-center">
      {message}
    </div>
  );
};

export default ErrorMessage;
